import React, {Component} from 'react';

import PropTypes from 'prop-types';
import TableComponentEnum from './../../utils/TableComponentEnum';

class TableRowColumn extends Component {
    constructor() {
        super();
        this.componentType = TableComponentEnum.ROWCOLUMN;
    }


  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    rowSpan: PropTypes.number,
    colSpan: PropTypes.number
  };

  state = {

  };

  onClick = (event) => {
  //  if (this.props.onClick) {
  //    this.props.onClick(event, this.props.columnNumber);
  //  }
  };

  render() {
    const {
      children,
      className,
      rowSpan,
      colSpan,
      onClick, // eslint-disable-line no-unused-vars
    } = this.props;

    const handlers = {
      onClick: this.onClick,
    };

    return (
      <td
        className={className}
        rowSpan={rowSpan}
        colSpan={colSpan}
        {...handlers}
      >
        {children}
      </td>
    );
  }
}

export default TableRowColumn;
